import { ArrowLeft } from "lucide-react";

import BrandLogo from "../components/BrandLogo";
import { NoIndex } from "../components/SeoMetadata";

export default function NotFoundPage() {
  return (
    <main className="not-found-page" data-testid="not-found-page">
      <NoIndex />
      <BrandLogo />
      <p className="section-eyebrow">404</p>
      <h1>Siden finnes ikke.</h1>
      <a className="button button--light" data-testid="not-found-home-link" href="/"><ArrowLeft size={16} />Tilbake til Urban Motors</a>
    </main>
  );
}